import React, { Component } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ForecastList from './List';
import ForecastCreate from './Create';
import ForecastDetail from './Detail';

const defaultCarbonFields = {
    Target: { visible: false, label: '', required: false },
    //Forecast: { visible: false, label: '', required: false },
    Actual: { visible: false, label: '', required: false },
    Variance: { visible: false, label: '', required: false }
}

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    ForecastDate: { visible: false, label: '', required: false },
    Details: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    CostForecast: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    let fields = { ...defaultFields };

    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.ForecastDate = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.FORECASTDATE"], required: true };
    fields.Details = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: true };
 
    var typeFieldEnabled = false;
    var clauses = [];

    //COST
    if (wfid == 52) {
        fields.CostForecast = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COSTFORECAST"], required: true };

        typeFieldEnabled = placeholdersQA.CostForecastClausesEnabled
            .values.find((phItem) => phItem.field === 'CostForecastClausesEnabled').isActive;

        clauses = placeholdersQA.CostForecastClauses
            .values.filter(item => item.isActive === true);
    }
    //CARBON
    else if (wfid == 53) {
        placeholdersQA?.Fields?.values.forEach(fieldItem => {
            if (defaultCarbonFields[fieldItem.field]) {
                defaultCarbonFields[fieldItem.field].label = fieldItem.isActive ? fieldItem.display : '';
                defaultCarbonFields[fieldItem.field].visible = fieldItem.isActive ? true : false;
            }
        });

        let carbonFields = {
            ...defaultCarbonFields,
            Forecast: { visible: true, label: resources.ForecastLabel, required: true }
        }

        fields = {
            ...fields,
            ...carbonFields
        };

        typeFieldEnabled = placeholdersQA.CarbonForecastClausesEnabled
            .values.find((phItem) => phItem.field === 'CarbonForecastClausesEnabled').isActive;

        clauses = placeholdersQA.CarbonForecastClauses
            .values.filter(item => item.isActive === true);
    }

    fields.Type = { visible: typeFieldEnabled, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };

    fields.Type.clauses = clauses;

    return fields;
}

class ForecastPmRouter extends Component {
    constructor(props) {
        super(props);

        this.notifyingParty = props.workflowItem.notifyingParty;

        if (props.mode === 'COST') {
            this.notificationType = 'CostForecast';
            this.documentType = 'DocumentCostForecast';
        }
        else if (props.mode === 'CARBON') {
            this.notificationType = 'CarbonForecast';
            this.documentType = 'DocumentCarbonForecast';
        }

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }

    shouldComponentUpdate() {
        return false;
    }

    render() {
        const { workflowItem } = this.props;

        return (
            <>
                <Routes caseSensitive>
                    <Route
                        path={workflowItem.config.paths.list}
                        exact
                        element={<ForecastList
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            notificationType={this.notificationType}
                        />}

                    />
                    <Route
                        path={workflowItem.config.paths.create}
                        exact
                        element={
                            workflowItem.userFilters.mainNotice.createAllowed ? (
                                <ForecastCreate
                                    {...this.props}
                                    notificationType={this.notificationType}
                                    title={this.notificationName}
                                />) : (
                                <Navigate replace to={workflowItem.paths.defaultPath} />
                            )
                        }
                    />
                    <Route
                        path={'/:notificationid/*'}
                        exact
                        element={<ForecastDetail
                            {...this.props}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={this.documentType}
                            notificationType={this.notificationType}
                            notifyUserFilter={workflowItem.notifyUserFilter}
                        />}
                    />
                </Routes>
            </>
        );
    }
}



export default (ForecastPmRouter);